import React from "react";
import { Row, Space } from "antd";
import Link from "antd/lib/typography/Link";
// import arrowBack from "../../../assets/namespace/icons/arrowBack.svg";
import { IBackBtnProps } from "./BackBtnComponent.types";
import "./BackBtnComponent.scss";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

const BackBtnComponent = ({ label, title, classname }: IBackBtnProps) => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="BackBtn">
      <Row className={`BackBtn ${classname ? classname : ''}`} align="middle" justify="center" >
        <Link
          onClick={goBack}
          target={"_self"}
          title={title}
        >
          <Space size={8}>
            {/* <img src={arrowBack} alt={"arrowBack"} /> */}
            <ArrowLeftOutlined style={{ color: '#004CC6' }} />
            <div className={"BackBtn"}>{label}</div>
          </Space>
        </Link>
      </Row>
    </div>
  );
};

export default BackBtnComponent;
